module.exports = function getResource(label, vars = []) {
    let resources = {
        inStoreServices: 'Services en magasin',
        makeoverAt: '- Séance maquillage chez',
        findStore: 'Trouver en magasin'
    };
    return resources[label];
};
